import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import useSettings from "../../data/useSettings";
import useShippingProviders from "../../data/useShippingProviders";
import AdminSettingsTable from "../../components/adminSettings/AdminSettingsTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { IShippingProvider } from "../../models/ShippingProvider";
import Modal from "../../layouts/Modal";
import GenericForm from "../../components/shared/GenericForm";
import { ISetting } from "../../models/Setting";
import { CheckCircleIcon } from "@heroicons/react/24/solid";

export default function AdminShippingProviders() {
  const { setInfo } = usePageNameContext();
  const { saveHandlers } = useDefaultCRUDHandlers("Shipping Provider");
  // const { shippingSettings, loading, update } = useSettings();
  const [selectedProvider, setSelectedProvider] = useState<IShippingProvider | undefined>(undefined);
  const { shippingProviders, updateSettings } = useShippingProviders();

  useEffect(() => {
    setInfo({
      name: "Admin Shipping Providers",
      desc: "View and configure your shipping providers",
    });
  }, []);

  if (shippingProviders.isLoading) {
    return <LoadingWheel />;
  }

  const handleSave = (settings: Record<string, string>) => {
    console.log("saving settings for provider:", selectedProvider?.providerName);
    console.log("settings:", settings);

    updateSettings.mutate({
      settings: settings,
      providerId: selectedProvider?.providerId,
    },
    {
      onSuccess: () => {
        setSelectedProvider(undefined);
        saveHandlers.onSuccess();
      },
      onError: (error) => {
        console.error("Error saving settings:", error)
      },
    });
  };

  return (
    <>
      <Modal
        open={!!selectedProvider}
        setOpen={() => setSelectedProvider(undefined)}
        width="max-w-lg"
      >
        {selectedProvider && (
          <div>
            <h1 className="text-xl font-semibold mb-4">{selectedProvider.providerName}</h1>
            <GenericForm<any> 
              prototypeObject={selectedProvider.requiredSettings}
              onSuccess={handleSave}
              cleanLabel={false}
              hideInputs={true}
            />
          </div>
        )}
      </Modal>

      <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
        {shippingProviders.data?.data.map((provider) => {
          const settings = provider.requiredSettings ?? {};

          const setCount = Object.values(settings).filter((val) => val?.trim() !== "").length;

          // const allSet =
          //   Object.keys(settings).length > 0 &&
          //   Object.values(settings).every((val) => val?.trim() !== "");

          const anySet = Object.values(settings).some((val) => val?.trim() !== "");

          const isSelected = provider.providerId === selectedProvider?.providerId;

          return (
            <div key={provider.providerId} className={`
              p-4 border rounded-lg shadow cursor-pointer text-center
              hover:scale-110 transition-all duration-200
              text-lg font-semibold relative 
              ${anySet ? ` ` : "bg-gray-200 text-gray-400 hover:bg-gray-300 hover:text-gray-600"}
            `}
              style={{ 
                backgroundColor: anySet ? provider.secondaryColor : "",
                color: anySet ? provider.primaryColor : "",
              }}
              onClick={() => setSelectedProvider(provider)}
            >
              <img 
                src={provider.logoUrl} 
                alt={provider.providerName} 
                className="mx-auto my-2 h-8" 
                />
              <small className="absolute top-2 right-2 text-xs">{provider.providerName}</small>
              {/* <img 
                src={provider.logoUrl} 
                alt={provider.providerName} 
                className="h-6 absolute top-[-10px] right-[-10px]" 
              /> */}
              <div className="absolute top-2 left-2 text-xs">
                {setCount} / {Object.keys(settings).length}
              </div>

              {anySet && <div className="absolute bottom-2 right-2 text-xs">
                <CheckCircleIcon className={`h-4 w-4`} />
              </div>}
            </div>
          )
        })}
      </div>
    </>
  );
  
}